var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.rootClass,attrs:{"id":"app"}},[_c('nprogress-container'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }